module.exports = __webpack_public_path__ + "static/media/LOUAY KHARRAT.a00e6f17.png";